/**
 * WifiUnlock.tsx
 * --------------
 * Shows Wi-Fi unlock instructions after passing the test.
 * - Multilingual support.
 */

import React from 'react';
import { useProgress } from '../../context/ProgressContext';
import { Link, useHistory } from 'react-router-dom';
import Button from '../common/Button';

const WifiUnlock: React.FC = () => {
  const history = useHistory();

  const { language } = useProgress();
  const lang = (['en', 'fi', 'sv'].includes(language) ? language : 'fi') as 'en' | 'fi' | 'sv';

  const t = {
    unlockTitle: {
      en: 'Wi-Fi Unlocked',
      fi: 'Wi-Fi avattu',
      sv: 'Wi-Fi upplåst',
    },
    congrats: {
      en: 'Congratulations!',
      fi: 'Onnittelut!',
      sv: 'Grattis!',
    },
    completed: {
      en: 'You have successfully completed the tutorial.',
      fi: 'Olet suorittanut opastuksen onnistuneesti.',
      sv: 'Du har slutfört handledningen.',
    },
    follow: {
      en: 'Follow the instructions below to unlock Wi-Fi access:',
      fi: 'Noudata alla olevia ohjeita avataksesi Wi-Fi-yhteyden:',
      sv: 'Följ instruktionerna nedan för att låsa upp Wi-Fi-åtkomst:',
    },
    step1: {
      en: 'Connect to the Wi-Fi network named "Tutorial_WiFi".',
      fi: 'Yhdistä Wi-Fi-verkkoon nimeltä "Tutorial_WiFi".',
      sv: 'Anslut till Wi-Fi-nätverket "Tutorial_WiFi".',
    },
    step2: {
      en: 'Enter the password: ',
      fi: 'Syötä salasana: ',
      sv: 'Ange lösenordet: ',
    },
    step3: {
      en: 'Enjoy your internet access!',
      fi: 'Nauti internet-yhteydestäsi!',
      sv: 'Njut av din internetåtkomst!',
    },
    goHome: {
      en: 'Go to Home',
      fi: 'Siirry etusivulle',
      sv: 'Gå till startsidan',
    },
  };

  return (
    <div className="flex flex-col items-center justify-center gap-3">
      <h1 className="text-2xl font-bold">{t.congrats[lang]}</h1>
      <p className="text-lg">{t.completed[lang]}</p>
      <p className="text-lg">{t.follow[lang]}</p>
      <div className="list-decimal list-inside mb-4">
        <li>{t.step1[lang]}</li>
        <li>
          {t.step2[lang]}
          <strong>[******]</strong>
        </li>
        <li>{t.step3[lang]}</li>
      </div>
      <Button onClick={() => {history.push('/');}} gradient>
        {t.goHome[lang]}
      </Button>
    </div>
  );
};

export default WifiUnlock;
